import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { setSubscribeFormData } from 'src/application/lazy/subscribe/actions';
import { getSubscribe } from 'src/application/lazy/subscribe/selectors';
import {
  SubscribeForm as IProps,
} from 'infrastructure/gatsby/types/subscribe-form';
import SubscribeFormComponent
  from '@shipae/components-sandbox/component/subscribe-form/regular';
import SubscribeFormTheme
  from '@shipae/components-sandbox/component/subscribe-form/regular/theme';
import { loadComponent } from 'src/application/core/control/actions';
// import {useTranslation} from 'views/misc/localization';

const SubscribeForm: React.FC<IProps> = ({
  ...content
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadComponent('subscribe'));
  }, []);
  const {
    subscribeFormData: formData,
  } = useSelector(getSubscribe);
  const { email } = formData;
  // const { locale } = useTranslation('');

  const handleSubmit = (e: React.FormEvent) => {
    // TODO submission
    e.preventDefault();
  };

  const handleEmailChange = (v: string) => {
    // TODO validation
    dispatch(setSubscribeFormData({
      ...formData,
      email: {
        ...email,
        value: v,
      },
    }));
  };

  return (
    <SubscribeFormComponent
      title={content.title}
      emailLabel={content.emailLabel}
      onSubmit={handleSubmit}
      onEmailChange={handleEmailChange}
      emailValue={email.value}
      emailError={email.error}
      theme={{
        ...SubscribeFormTheme,
        Main: styled(SubscribeFormTheme.Main)`
          width: auto;
        `,
      }}
    />
  );
};

export default SubscribeForm;
